var map = {
	"./en-201.json": "1b94",
	"./en-203.json": "ztBM",
	"./en-418502.json": "sSDZ",
	"./en.json": "NuBg",
	"./ko-201.json": "QX3D",
	"./ko-203.json": "rdlY",
	"./ko-418502.json": "VX+Z",
	"./ko.json": "N2Z1"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/IeC";


//////////////////
// WEBPACK FOOTER
// ./src/locales \.json$
// module id = /IeC
// module chunks = 1